import PartnerFormContainer from "./container/PartnerFormContainer";
import "./SCSS/styles.css";
export default PartnerFormContainer;
